import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { IPaymentCard } from '@/features/cards/store/models/card.model';

import { DashboardHelpers } from '@/utils/DashboardHelpers';

export function useUserCardOverview(cards: IPaymentCard[]) {
  const totalRows = cards?.[0]?.totalRows;

  const navigate = useNavigate();
  const handleNavigate = useCallback(
    (card?: IPaymentCard) => {
      if (cards?.length) {
        const { userId, cardId } = card || cards[0];
        navigate(DashboardHelpers.generateProfilePath(userId, { cardId }));
      }
    },
    [cards, navigate],
  );

  const sortedCards = [...cards].sort((a, b) => {
    const isAUnlocked = a?.statusCode === 'UNLOCK';
    const isBUnlocked = b?.statusCode === 'UNLOCK';
    if (isAUnlocked && !isBUnlocked) return -1;
    if (!isAUnlocked && isBUnlocked) return 1;

    const isALive = a?.isLive === 1;
    const isBLive = b?.isLive === 1;
    if (isALive && !isBLive) return -1;
    if (!isALive && isBLive) return 1;

    try {
      const dateA = new Date(a?.createdDate);
      const dateB = new Date(b?.createdDate);
      if (isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) return 1;
      if (!isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return -1;
      return dateB.getTime() - dateA.getTime();
    } catch (e) {
      console.error(e);
      return 0;
    }
  });

  const hasAllCards = sortedCards?.length <= 2;
  const displayedCards = hasAllCards ? sortedCards : sortedCards.splice(0, 2);

  return {
    displayedCards,
    hasAllCards,
    handleNavigate,
    totalRows: totalRows || cards?.length,
  };
}
